import * as React from 'react';

import './help-video-popup.scss';
import YouTubePlayer from 'components/youtube-player/YouTubePlayer';
import SVGDynamicIcon from 'components/svg-dynamic-icon/SVGDynamicIcon';

import { __t, applyTranslations } from 'utils/language';

import type { VideoTutorialEntry } from '../../types/VideoTutorialEntry.type';

applyTranslations(require('./help-video-popup.i18n.json'));

type Props = {
  playlist: Array<VideoTutorialEntry>,
  isAutoplay?: boolean,
  onClose: () => void,
  onNextVideo: () => void,
  onPreviousVideo: () => void
};

const HelpVideoPopup: React.FunctionComponent<Props> = (
  {
    playlist,
    isAutoplay,
    onClose,
    onNextVideo,
    onPreviousVideo
  }: Props
) => {
  if (playlist.length === 0) {
    return null;
  }

  return (
    <div className="help-video-popup">
      <div className="help-video-popup__title text-overflow-ellipsis">
        {playlist[0].name}
      </div>
      <div className="help-video-popup__close-button">
        <SVGDynamicIcon
          name="cross-custom-fg"
          width={15}
          height={15}
          customColor="grey"
          clickable
          onClick={onClose}
        />
      </div>
      <YouTubePlayer
        name="help-video"
        videoId={playlist[0].id}
        isAutoplay={isAutoplay}
        onNextVideo={onNextVideo}
      />
      {playlist.length > 1 && (
        <div className="help-video-popup__controls">
          <div className="help-video-popup__control-button">
            <SVGDynamicIcon
              name="chevron-left-custom-fg"
              width={15}
              height={15}
              customColor="grey"
              clickable
              onClick={onPreviousVideo}
            />
          </div>
          <div className="help-video-popup__next-video-title-container text-overflow-ellipsis">
            <span
              className="help-video-popup__next-video-title"
              onClick={onNextVideo}
            >
              {__t('help_video_popup.next_video_label')} "{playlist[1].name}"
            </span>
          </div>
          <div className="help-video-popup__control-button">
            <SVGDynamicIcon
              name="chevron-right-custom-fg"
              width={15}
              height={15}
              customColor="grey"
              clickable
              onClick={onNextVideo}
            />
          </div>
        </div>
      )}
    </div>
  );
};

export default HelpVideoPopup;
